import {
  LinearProgress,
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
} from "@mui/material";
import Box from "@mui/material/Box";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import ResponsiveDataGrid from "../../../../../../components/MobileList/ResponsiveDataGrid";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/ar";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { JReports } from "../../../../../../app/slices/jomla/reportsSlice";

const JRepTable = () => {
  const dispatch = useDispatch();
  const [selectedMonth, setSelectedMonth] = useState(null);

  // Set dayjs to use Arabic locale
  dayjs.locale("ar");

  const _JRep = useSelector((state) => state.jReports.jRep);
  const loading = useSelector((state) => state.jReports.loading);
  const reportTypes = useSelector((state) => state.jReports.reportTypes);

  const columns = [
    {
      field: "index",
      headerName: "#",
      flex: 0.2,
    },
    {
      field: "name",
      headerName: "اسم المندوب",
      flex: 1,
      renderCell: (params) => {
        return <Typography variant="h4">{params.row.name}</Typography>;
      },
    },
    {
      field: "mobile",
      headerName: "رقم الهاتف",
      flex: 1,
    },
    {
      field: "j_cash",
      headerName: "الكاش (IQD)",
      flex: 1,
      renderCell: (params) => {
        return <Typography>{params.row.j_cash?.toLocaleString()}</Typography>;
      },
    },
    {
      field: "pos_count",
      headerName: "نقاط البيع التابعة للمندوب",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography>{params.row.pos_count?.toLocaleString()}</Typography>
        );
      },
    },
    {
      field: "pos_j_balance",
      headerName: "ديون نقطة البيع",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography>{params.row.pos_j_balance?.toLocaleString()}</Typography>
        );
      },
    },
    {
      field: "clearance_amount",
      headerName: "التسديدات خلال الشهر",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography>
            {params.row.clearance_amount?.toLocaleString()}
          </Typography>
        );
      },
    },
    {
      field: "pos_orders_count",
      headerName: "عدد الطلبات خلال الشهر",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography>
            {params.row.pos_orders_count?.toLocaleString()}
          </Typography>
        );
      },
    },
    {
      field: "pos_orders_amount",
      headerName: "مجموع الطلبات خلال الشهر",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography>
            {params.row.pos_orders_amount?.toLocaleString()}
          </Typography>
        );
      },
    },
  ];

  useEffect(() => {
    if (selectedMonth !== null) {
      const timeout = setTimeout(() => {
        const firstDayOfMonth = dayjs(selectedMonth)
          .startOf("month")
          .format("YYYY-MM-DD");
        dispatch(JReports.jRep({ date: firstDayOfMonth }));
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [dispatch, reportTypes, selectedMonth]);

  const customToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarExport
        csvOptions={{
          fileName: "تقرير المندوبين | نظام دجلة",
          utf8WithBom: true,
        }}
      />
    </GridToolbarContainer>
  );

  return (
    <Card>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ar">
              <DatePicker
                label="اختر الشهر"
                value={selectedMonth}
                onChange={(newValue) => setSelectedMonth(newValue)}
                views={["year", "month"]}
                renderInput={(params) => (
                  <TextField size="small" {...params} fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ height: { xs: "auto", md: "80vh" }, width: "100%" }}>
              <ResponsiveDataGrid gridHeight={null}
                rows={
                  _JRep.data?.map((x, index) => ({ ...x, index: index + 1 })) ??
                  []
                }
                loading={loading}
                columns={columns}
                components={{
                  LoadingOverlay: LinearProgress,
                  Toolbar: customToolbar,
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default JRepTable;
